import LoadingOverlay from '@components/LoadingOverlay/LoadingOverlay';
import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';
import useTasks from '@modules/TasksModule/hooks/useTasks';

interface TaskLoadingOverlayProps {
  children: React.ReactNode | React.ReactNode[];
  taskId?: string;
}

/**
 * TaskLoadingOverlay component.
 *
 * This component will be used to show a loading overlay over the task that is in phoneState.callAccepting or the task.loading is true.
 */
const TaskLoadingOverlay = ({ children, taskId }: TaskLoadingOverlayProps) => {
  const { callsAccepting } = usePhoneState();
  const { taskById } = useTasks();

  if (!taskId) {
    return <>{children}</>;
  }

  const task = taskById[taskId];

  if (!task) {
    return <>{children}</>;
  }

  const callAccepting = !!callsAccepting.find(
    (callId) => callId === task?.attributes?.callId,
  );

  const loading = task.loading ?? callAccepting;

  return <LoadingOverlay loading={loading}>{children}</LoadingOverlay>;
};

export default TaskLoadingOverlay;
